
import React, { useState, useEffect } from 'react';
import { useHomePageContentStore } from 'src/hooks/HomePageContent';
import Pagination from "src/component/Global/Pagination"
import { useSearchParams } from 'react-router-dom';
import Helper from 'src/helper/Helper';
import useReduxState from 'src/hooks/useReduxState';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { __remove, __set } from 'src/store/axios_indicator';
import Constants from 'src/helper/Constants';
import ReusableDiv from 'src/helper/ReusableDiv';
import ContentFilter from './ContentFilter';
import ContentTabCommonSorting from './ContentTabCommonSorting';
import NoResultContent from '../NoResultContent';
import AxiosIndicatorRunTimeLoader from 'src/component/Global/AxiosIndicatorRunTimeLoader';

const VideoTab = () => {

    const [{ }, { get_home_page_content }] = useHomePageContentStore();
    const [list, setList] = useState([]);
    const [firstServerCall, setFirstServerCall] = useState(true);
    const [searchParams] = useSearchParams();
    const [__check] = useAxiosIndicatorCheck();
    const [listObj, setListObj] = useState({ pageCount: 0, page: 1, limit: 20, sortBy: 'Relevance' });
    const { homePageAllTabs } = Constants;
    const [selectedFilterList] = useReduxState([], 'selectedFilterList');
    const [filterFacets, setFilterFacets] = useReduxState([], 'setFilterFacets');
    const [callFirstTime, setCallFirstTime] = useState(true);

    useEffect(() => {
        const fetchList = async () => {
            await fetchAPiCall();
            setFirstServerCall(false);
        };
        fetchList();
    }, []);

    useEffect(() => {
        const getList = async () => {
            if (listObj.page === 1) {
                await fetchAPiCall()
            } else {
                setListObj({ ...listObj, page: 1 })
            }
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [listObj.limit, listObj.sortBy, selectedFilterList]);

    useEffect(() => {
        const getList = async () => {
            await fetchAPiCall()
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [listObj.page]);


    const handlePageClick = (data) => {
        const newPage = data.selected + 1;
        setListObj({ ...listObj, page: newPage });
        Helper.scrollTop();
    };

    const setPageLimit = (event) => {
        const newLimit = Number(event.target.value);
        setListObj({ ...listObj, limit: newLimit });
    };

    const fetchAPiCall = async () => {
        const filterBy = selectedFilterList.map((v) => v.filterName);
        const searchKeyword = searchParams.get('search');

        __set('CONTENT_API_CALL');

        const data = await get_home_page_content({
            pageNumber: listObj.page,
            pageSize: listObj.limit,
            orderBy: listObj.sortBy,
            searchTerm: searchKeyword,
            filterBy,
            contentType: homePageAllTabs.VIDEO.contentType,
        });

        const totalCount = data[homePageAllTabs.VIDEO.contentType]?.totalCount || 0;
        setListObj({ ...listObj, pageCount: Math.ceil(totalCount / listObj.limit) });
        setList(data[homePageAllTabs.VIDEO.contentType]?.webContentView || []);

        if (callFirstTime) {
            setCallFirstTime(false);
            setFilterFacets(data[homePageAllTabs.VIDEO.contentType].avnFilters);
        }

        __remove('CONTENT_API_CALL');
    };
    const onFilter = async (e) => {
        setListObj({ ...listObj, sortBy: e.target.value })
    }

    return (
        <div id="contentTypeVideo" className="tab-pane fade active in">
            <div className='videos-content-wrapper'>
                <div className='bs5 row'>
                    <div className='col-lg-3 tab-sidebar'>
                        <ContentFilter />
                        {ReusableDiv.newsLetterAd()}
                    </div>
                    <div className='col-lg-9 tab-data'>
                        <div className='all-content'>

                            <ContentTabCommonSorting onFilter={onFilter} headerNme={homePageAllTabs.VIDEO.tabHeader} dataLength={list.length} />
                            <hr />
                            {__check(['CONTENT_API_CALL', 'ALL_CONTENT_COUNT_API_CALL']).status ? <AxiosIndicatorRunTimeLoader /> :
                                <div className='position-relative'>
                                    <div className='all-content-body'>
                                        <div className='bs5 row'>
                                            {list.length > 0 ? (
                                                list.map((v, i) => (
                                                    <div key={i} className='col-sm-12 col-md-6 col-lg-4 m-b-30'>
                                                        <div className='video-item'>
                                                            <div className='video-iframe'>
                                                                <iframe
                                                                    src={v?.url}
                                                                    frameBorder='0'
                                                                    allow='autoplay; encrypted-media'
                                                                    allowFullScreen
                                                                    title='video'
                                                                />
                                                            </div>
                                                            <div className='text-blue2 font-bold font-16'>
                                                                <a href={v?.url} target='_blank' rel='noreferrer' className='text-blue2'>
                                                                    {v.name}
                                                                </a>
                                                            </div>
                                                            <div className='video-desc'>{v.longDescription}</div>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                firstServerCall === false && searchParams.get('search') && (
                                                    <NoResultContent message={`No Videos Found for <b>"${searchParams.get('search')}"</b>`} />
                                                )
                                            )}
                                        </div>
                                    </div>
                                    {list.length > 0 && (
                                        <Pagination pageCount={listObj.pageCount} handlePageClick={handlePageClick} setPageLimit={setPageLimit} page={listObj.page - 1} limit={listObj.limit} />
                                    )}
                                </div>
                            }

                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default VideoTab